import * as yup from 'yup';

function name(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'NAME_IS_REQUIRED',
        defaultMessage: 'Name is required',
      }),
    )
    .max(
      200,
      formatMessage({
        id: 'NAME_SHOULD_BE_LESS_THAN_200_CHARS',
        defaultMessage: 'Name should be less than 200 chars',
      }),
    );
}

function path(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'PATH_IS_REQUIRED',
        defaultMessage: 'Path is required',
      }),
    )
    .max(
      500,
      formatMessage({
        id: 'PATH_SHOULD_BE_LESS_THAN_500_CHARS',
        defaultMessage: 'Path should be less than 500 chars',
      }),
    );
}

function isActive(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'IS_ACTIVE_IS_REQUIRED',
      defaultMessage: 'Is Active is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      name: name(formatMessage),
      path: path(formatMessage),
      isActive: isActive(formatMessage),
    })
    .required();

export default validationSchema;
